<template>
  <div>
    <form-label v-if="label" :text="fieldLabel" :hint="fieldHint" :for="id"></form-label>
    <div class="uk-form-controls">
      <div target="true" slot="field" class="uk-flex" uk-form-custom v-if="showSelected">
        <input type="file" :name="name" :multiple="multiple" :disabled="!enabled" @change="updateSelectedFiles" @blur="triggerChangeAndValidate" ref="input">
        <input class="uk-input uk-flex-1" :class="{'uk-form-danger': isDanger, 'uk-form-success': isSuccess}" type="text" :id="id" :value="selectedFiles" readonly :placeholder="$t('frontend-bertos.form.file_placeholder')">
        <button type="button" class="uk-button uk-button-default">{{ buttonLabel }}</button>
      </div>
      <div slot="field" class="uk-width-1-1" uk-form-custom v-else>
        <input type="file" :id="id" :name="name" :multiple="multiple" ref="input" @blur="triggerChangeAndValidate">
        <button type="button" class="uk-button uk-button-default uk-width-1-1" :disabled="!enabled">{{ buttonLabel }}</button>
      </div>
    </div>
    <small class="uk-display-block" v-text="fieldHint" v-if="fieldHint"></small>
    <form-error v-for="(error, index) in errors" :key="index" :error="error"></form-error>
  </div>

</template>

<script>
  import FormField from "rubinred/forms/js/mixins/FormField";

  export default {
    mixins: [FormField],
    props: {
      value: {
        type: Array,
        default: () => []
      },
      showSelected: {
        type: Boolean,
        default: true,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      buttonLabel: {
        type: String,
        default: 'Select'
      },
      isMultipart: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        selectedFiles: '',
        fieldValue: []
      }
    },
    methods: {
      updateSelectedFiles() {
        if (!this.$refs.input) {
          return;
        }

        this.fieldValue = [];
        for (let i = 0; i < this.$refs.input.files.length; i++) {
          this.fieldValue.push(this.$refs.input.files[i]);
        }

        this.selectedFiles = this.fieldValue.map(file => file.name).join(', ');
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/extensions/rubinred/forms/assets/js/components/FormFile.vue